import ScorecardDesignerDataExtractor from 'scoreboard/reports/scorecard-report/scorecard-report-data-extractor'
import selectItemTemplate from './select-item.hbs'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'

/** Provides formatting specific to mass edit report results */
class MassEditDataExtractor extends ScorecardDesignerDataExtractor {

	// formats the id column to contain a checkbox with the value of the id
	applyIdFormatting(result, resultItem) {
		// make a checkbox
		let id = resultItem.id
		result.html = selectItemTemplate({ id, editable: true })
		return result
	}

	// adds a link with a data-item-id to label items
	applyTextFormatting(val, columnType, resultItem) {
		let html = escapePreserveLineBreaks(val)
		// create a link with a data-item-id for item labels
		if (columnType === 'label') {
			html = `<a class='text-link' data-item-id='${resultItem.id}'>${val}</a>`
		}
		return html
	}
}

export default MassEditDataExtractor
MassEditDataExtractor.__filename__ = 'admin/mass-edit/mass-edit-data-extractor.js'
